import { Box, Typography } from "@mui/material";
import { EntityTypeInfo } from "../../../stack/environment/components/constants";

import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons } from "../../../stack/environment/icons/iconExport";

const AssetCard = ({ name, value }) => {
  const colors = useColors();
  const AllEntityTypeInfo = {
    ...EntityTypeInfo,
    Tenants: {
      title: "Tenants",
      icon: icons.MultiTenantIcon,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderRadius: "16px",
        backgroundColor: colors.common_white,
        padding: "20px",
        gap: "20px",
        boxShadow: "0px 0px 4px 0px " + colors.primary_48percent,
        minWidth: "185px",
        minHeight: "48px",
      }}
    >
      <Box
        sx={{
          width: "40px",
          height: "40px",
          backgroundColor: colors.primary_8percent,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: colors.primary_main,
          padding: "8px",
        }}
      >
        <SvgToIcon
          IconLogo={AllEntityTypeInfo[name].icon}
          style={{ width: "32px", height: "32px" }}
        />
      </Box>
      <Box>
        <Typography variant="subtitle2">
          {AllEntityTypeInfo[name].title}
        </Typography>
        <Typography variant="body2">{value}</Typography>
      </Box>
    </Box>
  );
};

export default AssetCard;
